<template>
  <div class="avatar" :class="{ 'rounded-full': rounded }" :style="{'--avatar-size': sizePx + 'px',}"
  >
    <img
      v-if="showImg"
      :src="src"
      :alt="alt || $t('general.avatar')"
      class="avatar_img"
      @error="onError"
    />
    <div v-else class="avatar_icon" aria-hidden="true">
      <i class="uil-user-circle"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvatarOrIcon',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    sizePx: { type: Number, default: 36 },
    rounded: { type: Boolean, default: true },
  },
  data() {
    return { imgError: false }
  },
  computed: {
    isPlaceholder() {
      if (!this.src) return true
      const normalizedSrc = this.src.toLowerCase()
      return normalizedSrc.includes('not-found.png') || normalizedSrc.includes('placeholder') || normalizedSrc.includes('default')
    },
    showImg() {
      return !this.imgError && !this.isPlaceholder
    },
  },
  methods: {
    onError() { this.imgError = true }
  }
}
</script>

<style scoped>
.avatar {
  width: var(--avatar-size);
  height: var(--avatar-size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff; 
}

.avatar_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.avatar_icon {
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.avatar_icon i {
  font-size: var(--avatar-size);
  line-height: 1;
  color: #e11d48;
}

.rounded-full { border-radius: 9999px; }
</style>
